export default "__VITE_ASSET__D8px8$yS__"